var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getEvents.length > 0)?_c('b-list-group',_vm._l((_vm.getEvents),function(Event,idx){return _c('EventListItem',{key:Event.EventID,attrs:{"Event":Event,"idx":idx}})}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }